import { useQuery } from '@apollo/client';
import RoutePath from 'App/RoutePath';
import { TokenInvalidMessage } from '__generated__/globalTypes';
import useFeatureFlag from 'flags/useFeatureFlag';
import gql from 'graphql-tag';
import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const VALIDATE_TOKEN_QUERY = gql`
  query isValidInvitationToken($input: IsValidInvitationTokenInput!) {
    isValidInvitationToken(input: $input) {
      tokenIsValid
      message
    }
  }
`;

export const useValidateInvitationToken = () => {
  const history = useHistory();
  const location = useLocation();

  const invitedUserToken = useMemo(
    () => new URLSearchParams(location.search).get('invite_token'),
    [location.search],
  );

  const isNewInviteFlowEnabled = useFeatureFlag(
    'team-growth-new-send-invite-flow',
  );

  const shouldRunQuery = isNewInviteFlowEnabled && !!invitedUserToken;

  const { data } = useQuery(VALIDATE_TOKEN_QUERY, {
    variables: { input: { token: invitedUserToken } },
    skip: !shouldRunQuery,
  });

  useEffect(() => {
    const tokenCheck = data?.isValidInvitationToken;
    if (!tokenCheck) return;

    if (tokenCheck.tokenIsValid) return;

    if (tokenCheck.message === TokenInvalidMessage.INVITEES_LIMIT_REACHED) {
      history.push(RoutePath.InviteesLimitReached);
    } else {
      history.push(RoutePath.InvalidInviteToken);
    }
  }, [data, history]);

  const tokenIsValid = data?.isValidInvitationToken?.tokenIsValid ?? false;

  return {
    tokenIsValid,
    validToken: tokenIsValid ? invitedUserToken : null,
    hasLovedOneInvitationCode: isNewInviteFlowEnabled && !!invitedUserToken,
  };
};
